
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddressIcon from "../../Images/imagges.png";
import axios from 'axios';
const ImageSelection = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const selectedImage = e.target.files[0];
    if (selectedImage) {
      const formData = new FormData();
      formData.append('image', selectedImage);

      try {
        setLoading(true)
        const response = await axios.post('https://ecommerce-tg2w.onrender.com/product/searchWithImage', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        // Navigate to the SearchResult component and pass the response data
        setLoading(false)
        navigate('/search-result', { state: { products: response.data.products } });
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }
  };
  return (
    <div style={{ position: "relative", left: "40px" }}>
      {loading && <div class="spinner-border text-warning" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>}
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <div onClick={handleIconClick}>
        {!loading &&
          <img style={{ cursor: "pointer", width: "30px", height: "30px" }} src={AddressIcon} />
        }
      </div>
    </div>
  );
};

export default ImageSelection;
